import { Component } from 'react';
import styles from './PhoneNumberButton.module.css';

export class PhoneNumberButton extends Component {
    getLinkValue() {
        const { callPhoneNumber } = this.props;

        return `tel:${callPhoneNumber}`;
    }

    render() {
        const { displayPhoneNumber } = this.props;
        const linkValue = this.getLinkValue();

        return (
            <div className={styles.PhoneNumberButton}>
                <a className={styles.PhoneNumber} href={linkValue}>
                    {displayPhoneNumber}
                </a>
            </div>
        );
    }
}
